import { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { store } from "../configureStore";

import { persistor } from "../configureStore";
import { useApi } from "./ApiProvider";
import { userActions } from "../actions/";

const ADMIN = process.env.NODE_ENV ?
    process.env.REACT_APP_ADMIN :
    window.env.ADMIN;

const UserContext = createContext();

export default function UserProvider({ children }) {
  const [user, setUser] = useState();
  // const [presurvey, setPresurvey] = useState();
  const api = useApi();
  var progress = useSelector((state) => state.survey.surveyHistory);
  const dispatch = useDispatch();

  const isAdmin = user ? user.is_admin || user.is_admin == 1 ? true : false : false;

  // console.log("UserProvider", user);
  // console.log("isAdmin here", isAdmin);

  useEffect(() => {
    (async () => {
      if (api.isAuthenticated()) {
        const response = await api.get("/me");
        setUser(response.ok ? response.body : null);
      } else {
        setUser(null);
      }
    })();
  }, [api]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      save();
    }, 180000); // every 3 mins
    return () => clearInterval(intervalId);
  }, [progress]);

  const login = async (username, password) => {
    const result = await api.login(username, password);
    if (result === "ok") {

      // Fetch user
      const meRes = await api.get("/me");

      // Fetch consent record
      let consentData = { submitted: false, form_data: {} };
      const conRes = await api.get("/me/consent");
      if (conRes.ok) {
        console.log("Consent data", conRes.body);
        consentData = conRes.body;
      }

      // Fetch presurvey
      let presurveyData = { submitted: false, form_data: {} };
      const preRes = await api.get("/me/presurvey");
      if (preRes.ok) {
        presurveyData = preRes.body; 
      }

      //Fetch postsurvey
      let postsurveyData = { submitted: false, form_data: {} };
      const postRes = await api.get("/me/postsurvey");
      if (postRes.ok) {
        postsurveyData = postRes.body;
      }

      // Populate Redux store
      if (meRes.ok && meRes.body) {
        // Progress
        dispatch(userActions.initProgress(meRes.body.progress));

        // Consent
        if (consentData.submitted) {
          console.log('user provider consent signed')
          dispatch(userActions.consentSigned());
        } else {
          console.log('user provider consent not signed')
        }

        // Presurvey
        dispatch(userActions.updatePreSurveySelection(presurveyData.form_data));
        if (presurveyData.submitted) {
          dispatch(userActions.submitPreSurvey());
        }

        // Postsurvey
        dispatch(userActions.updatePostSurveySelection(postsurveyData.form_data));
        if (postsurveyData.submitted) {
          dispatch(userActions.submitPostSurvey());
        }

        // Set user so PrivateRoute sees a valid user
        setUser(meRes.body);
      }
    }
    return result;
  };
  
  const save = async () => {
    const progress = store.getState().survey.surveyHistory;
    await api.post(`/me/progress`, {
      // 'progress' is the entire Redux store for surveyHistory
      progress: progress,
    });
    console.log("Progress saved", progress);
  };

  const reset = async () => {
    dispatch(userActions.resetProgress());
    persistor.purge();
    await api.post(`/me/progress`, {
      progress: {},
    });
    window.location.reload();
  };

  const logout = async () => {
    await save();
    await api.logout();
    dispatch(userActions.logout());
    persistor.purge();
    setUser(null);
  };

  return (
    <UserContext.Provider
      value={{ user, setUser, isAdmin, login, logout, save, reset }}
    >
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
